"use client";

import { createContext, useContext } from "react";
import type { MessageKey, MessageParams, Messages } from "@/lib/i18n";
import { DEFAULT_LOCALE, type Locale } from "@/lib/locale";

type I18nContextValue = {
  locale: Locale;
  t: (key: MessageKey, params?: Record<string, string | number | boolean | null | undefined>) => string;
};

const I18nContext = createContext<I18nContextValue>({
  locale: DEFAULT_LOCALE,
  t: (key) => key
});

export function I18nProvider({ locale, messages, children }: { locale: Locale; messages: Messages; children: React.ReactNode }) {
  return (
    <I18nContext.Provider value={{ locale, t: (key, params) => formatMessage(messages[key] ?? key, params) }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n(): I18nContextValue {
  return useContext(I18nContext);
}

function formatMessage(template: string, params: MessageParams = {}): string {
  return template.replace(/\{([a-zA-Z0-9_.-]+)\}/g, (match, paramKey) => {
    const value = params[paramKey];
    return value === undefined || value === null ? match : String(value);
  });
}
